import * as _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';
import { loadVendor, setFormLoader, setLoader, upsertVendor, deleteVendor as deleteVendorFromRedux } from './reducer';

export function loadVendors() {
  return async (dispatch) => {
    dispatch(setLoader(true));
    let vendors = [];
    try {
      const response = await ApiService.getAllVendors();
      const successResponse = _.get(response, 'data.rpcService.success');
      if (!successResponse) {
        throw response;
      }
      const res = _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (res) {
        vendors = res;
        dispatch(loadVendor(res));
      } else {
        throw new Error('Vendors not found in api');
      }
    } catch (e) {
      dispatch(loadVendor([]));
      logUtils.logError(e, 'Loading Vendors Failed');
    } finally {
      dispatch(setLoader(false));
    }
    return vendors;
  };
}

export function updateVendor(vendor) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      const response = await ApiService.upsertVendor(vendor);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const updatedVendor =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!updatedVendor) throw new Error('Didnt receive updated Vendor from api');
      toastr.success('Vendor updated');
      dispatch(upsertVendor(updatedVendor));
    } catch (e) {
      logUtils.logError(e, 'Updating Vendor failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function createVendor(vendor) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      delete vendor.id;
      const response = await ApiService.upsertVendor(vendor);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const createdVendor =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!createdVendor) throw new Error('Vendor not created');
      toastr.success('Vendor Created');
      dispatch(upsertVendor(createdVendor));
    } catch (e) {
      logUtils.logError(e, 'Vendor creation failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function onSubmitButtonClicked(vendor) {
  return async (dispatch) => {
    const clonedVendor = _.clone(vendor);
    if (vendor.id) {
      await updateVendor(clonedVendor)(dispatch);
    } else {
      await createVendor(clonedVendor)(dispatch);
    }
  };
}

export function deleteVendor(vendor) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    const clonedVendor = _.clone(vendor);
    clonedVendor.isDeleted = true;
    try {
      const response = await ApiService.upsertVendor(clonedVendor);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      dispatch(deleteVendorFromRedux(vendor));
      toastr.success('Vendor Deleted');
    } catch (e) {
      logUtils.logError(e, 'Vendor  deleting failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}
